// extracted by mini-css-extract-plugin
export default {"item":"Item_item__ZanUx","lastItem":"Item_lastItem__k05qY","origin":"Item_origin__7J1s5","time":"Item_time__KnFMm","type":"Item_type__2myS1","description":"Item_description__ALmEp"};